import React from 'react';  // import the React library
import '../App.css'; // import your CSS file
import { motion } from 'framer-motion';
import BioLine from '../articleComponents/bioLine.js'; // import your CSS file
import Connect from '../articleComponents/connect';
import SocialMedia from '../articleComponents/SocialMedia';
import MetaTags from '../mainPageComponents/MetaTags';
import planet from '../pictures/planet_img.jpg';
import Image from '../mainPageComponents/image.js';
import TraversePosts from '../articleComponents/navigation';
import ahelmet from '../images/helmet.jpg';

const today = new Date("12, 31, 2020").toLocaleDateString('en-US', {  
  day:   'numeric',
  month: 'short',
  year:  'numeric',
  weekday: 'long'
});

function PutOnYourHelmet() {
    return (
        <motion.div className="articleStyle"
        initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>

<MetaTags title="Put On Your Helmet" desc="The evolution of a Helmet component from JSX text to a React Component to using props so I don't have to copy and paste my title 3 times anymore." 
URL="https://highway-60.firebaseapp.com/articles/put-on-your-helmet" imageURL={planet} author="David Ben Horin" />

        <h1>Put On Your Helmet</h1>

<Image picURL={ahelmet} alt="Put on Your Helmet" />

<BioLine />
<p>{today}</p>


<div style={{textAlign: "left", marginTop: "5px", marginBottom: "20px"}}>
<SocialMedia url="https://highway-60.firebaseapp.com/articles/put-on-your-helmet" title="Put on Your Helmet" hashtag="#highway60" hashtagArray={["marketing", "writing", "coding"]} 
via="TheHighway60" desc="The evolution of a Helmet component from JSX text to a React Component to using props so I don't have to copy and paste my title 3 times anymore." />
</div>

    <p>There is this amazing river right by where I live. It is deep in the Jordan Valley, the hottest place in Israel. On a bright spring day, it can be 80 degrees (27 C) outside, but the water is ice cold. </p>

<p>
The moment you go from the burn of the sun to the freeze of the cold, your body is flooded with adrenaline. It is a killer rush. 
</p>

<p>
I used to be a wuss about it. They have steps into the river. I would timidly put my feet in up to my ankles, then to my knees. Then to my hips. 
</p>

<p>
The stomach has more sensitive skin so it takes a little bit of psyching myself up. I’ll dip to my belly button and take a few deep breaths. Then, to get more comfortable, I would dip my arms in, put some water over my shoulders. 
</p>

<p>
Then, I would immerse the rest of my body into the water. 
</p>

<p>
All in all, it took about 10 minutes. 
</p>

<p>
After about a month, I got used to it. When we arrived at the top step, my wife and children would stand next to me and together we would go, “1, 2, 3 …..”
</p>

<p>
Whoosh! Right into the water. 
</p>

<p>
I would love to get to this point with my ReactJS skills, but I am still on my tippy toes at the kiddie end of the pool. 
</p>

<p>
That’s how I intend to install, and evolve my &#60;helmet &#62; tags so I can stop seeing “React” at the top of all my pages. 
</p>

<h1>The First Step</h1>

<p>
&#60;helmet&#62; is a library you can install to easily tailor everything in your &#60;head&#62; tags to the specific page you are working on. 
</p>

<p>
You can make your own &#60;meta&#62; tags, &#60;link&#62; tags, even script tags and &#60;style&#62; elements. Anything you can put inside your &#60;head&#62; tags in html, you can do with &#60;helmet&#62;.    
</p>

<p>
This is a pretty big deal because I am messing with my app.js page and the index.html page. It requires making changes to both so if I mess this up, uy vey. 
</p>

<p>
Let’s get cooking. 
</p>

<p>
I am listening to Chopin for focus right now so this should go smoothly. 
</p>

<p>
First step is to install.
</p>

<p>
Here are the docs:
<a href="https://www.npmjs.com/package/react-helmet">https://www.npmjs.com/package/react-helmet</a>
</p>

<p>
here is my npm command:
</p>

<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />
<code>{`
npm install --save react-helmet
`}</code><br />
<br />
</div>

<p>Woo hoo!</p>

<p>
    I am going to start with my articles.js page that shows my articles. Better import this sucker first.
</p>

<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />

<code>{`
import {Helmet} from "react-helmet";
`}</code><br />

<br />
</div>

<p>
    YEAH BABY.
</p>

<br />

<iframe width="560" height="315" src="https://www.youtube.com/embed/JBHKVAs85Ko?start=15" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

<br />

<p>
    Now, let’s do something simple, like a &#60;title&#62; and &#60;desc&#62;
</p>


<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />

<code>{`
  <Helmet>
`}</code><br />

<code>{`
  <title>Articles for Highway 60</title>
`}</code><br />
<code>{`
  <meta name="description" content="Articles for Highway 60. We talk about coding, marketing, writing, and the people and places that make the greatest land on earth come to life." /> 
`}</code><br />
<code>{`
  </Helmet>
`}</code><br />

<br />
</div>

<p>
    Okay. That’s good.
</p>

<p>
    Now, the moment of truth.
</p>

<p>
    Did it work?
</p>

<p>
    No. I still have the meta data from the index.html page.
</p>

<p>
    What if I deleted the title and meta desc info from this page?
</p>

<p>
    Hold this for me a minute, will you?
</p>

<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />

<code>{`
 <meta
`}</code><br />
<code>{`
name="description"
`}</code><br />
<code>{`
      content="Web site created using create-react-app"
`}</code><br />
<code>{`
    />
`}</code><br />
<code>{`

`}</code><br />
<code>{`
<title>React Application</title>
`}</code><br />

<br />
</div>

<p>
    First, let’s check up top:
</p>

<br />
<img src={process.env.PUBLIC_URL + "/images/helmet.png"} />
<br />

<p>
    That’s promising.
</p>

<p>
    But when I check my page source, I don’t see the new stuff I added?
</p>

<p>
    That’s okay. Stack Overflow tells me this:
</p>

<br />

<a href="https://stackoverflow.com/questions/60467530/react-helmet-not-showing-meta-tags-in-view-page-source-but-shows-in-element-on-i">https://stackoverflow.com/questions/60467530/react-helmet-not-showing-meta-tags-in-view-page-source-but-shows-in-element-on-i</a>

<br />

<p>
    Since this is a front end solution, and not from the server, it will not register on the page source, but it will be visible to the user, and to the Google SEO bots crawling my app.
</p>

<p>
    Double Woo Hoo!
</p>

<h1>
    Doing Something CRAZY!
</h1>

<br />

<p>
    Now, I would like to replace all my index.html &#60;head&#62; tags with the &#60;Helmet&#62;.
</p>

<p>
    Hold this, would you . . .
</p>

<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />

<code>{`
   <meta charset="utf-8" />
`}</code><br />
<code>{`
    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
`}</code><br />
<code>{`
    <meta name="viewport" content="width=device-width, initial-scale=1" />
`}</code><br />
<code>{`
    <meta name="theme-color" content="#000000" />
`}</code><br />
<code>{`
    <script src="https://use.fontawesome.com/ae82b2007b.js"></script>
`}</code><br />
<code>{`
    <link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" />
`}</code><br />
<code>{`
    <!--
    manifest.json provides metadata used when your web app is installed on a
    user's mobile device or desktop. See https://developers.google.com/web/fundamentals/web-app-manifest/
  -->
`}</code><br />
<code>{`
    <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
`}</code><br />
<code>{`
<link rel="preconnect" href="https://fonts.gstatic.com">
`}</code><br />
<code>{`
<link href="https://fonts.googleapis.com/css2?family=Gentium+Book+Basic&family=Yesteryear&display=swap" rel="stylesheet">
`}</code><br />

<br />
</div>

<p>
    Okay. I had to erase the comments, and I lost my CSS stylings, but the app runs.
</p>

<p>
    The problem is that I am running my prototype &#60;Helmet&#62; on my articles.js page. I will have to copy and paste it to my app page to get back the stylings. (yes – make a component – but we are still dipping our toe!)
</p>

<p>
    Got it! Styles are back. I have an empty &#60;head&#62; tag in my index.html file, and a full &#60;helmet&#62; in my home page and article page.
</p>

<p>
    Heh, heh, heh. I even replace the favicon.ico image to my highway 60.
</p>

<br />

<h1>
    Let’s Get Wet!
</h1>

<br />

<p>
    Now it’s time to dive in!
</p>

<p>
    Let’s make a component.
</p>

<p>
    I am going to create a MetaTags.js file and put all this goodness into it. Then I will call the component onto my home page and articles page.
</p>

<p>
    Yeah!
</p>

<p>
    The only quirk is that I have to import the &#123;Helmet&#125; hook from ‘react-helmet’ into every page I call my &#60;Helmet&#62;.
</p>

<p>
    Good to know.
</p>

<br />

<h1>
    Dive Deep!
</h1>

<br />

<p>
    For the main event, we will insert props.
</p>

<p>
    Before we do that, I want to list all the meta tags I am used to working with:
</p>

<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />

<code>{`
<title>title</title>
`}</code><br />

<code>{`
<meta name="description" content="desc "/>
`}</code><br />

<code>{`

`}</code><br />

<code>{`
<meta name="og:site_name" content="Highway 60" />
`}</code><br />

<code>{`
<meta name="og:type" content="Application" />
`}</code><br />

<code>{`
<meta name="og:title" content="title " />
`}</code><br />

<code>{`
<meta name="og:description" content="desc" />
`}</code><br />

<code>{`
<meta name="og:url" content="url" />
`}</code><br />

<code>{`
<meta property="og:image" content="image"/> 
`}</code><br />

<code>{`

`}</code><br />

<code>{`
<meta name="twitter:card" content="summary_large_image" />
`}</code><br />

<code>{`
<meta name="twitter:creator" content="@TheHighway60" />
`}</code><br />

<code>{`
<meta name="twitter:title" content="title" />
`}</code><br />

<code>{`
<meta name="twitter: description" content="desc" />
`}</code><br />

<code>{`
<meta name="twitter: url" content="url" />
`}</code><br />

<code>{`
<meta property="twitter:image" content="image"/>
`}</code><br />

<br />
</div>

<p>
    For YEARS! I had to copy and paste my meta info to 2-3 places. This marks the end of a small annoyance. Thank G-d for props!
</p>

<p>
    Here is the <b>last time</b> I will copy and paste:
</p>

<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />

<code>{`
import React from 'react';  // import the React library
`}</code><br />

<code>{`
import {Helmet} from "react-helmet";
`}</code><br />

<code>{`

`}</code><br />

<code>{`
function MetaTags(props) {
`}</code><br />

<code>{`
    return (
`}</code><br />

<code>{`
        <>
`}</code><br />

<code>{`
          <Helmet>
`}</code><br />

<code>{`
<meta charset="utf-8" />
`}</code><br />

<code>{`
<link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
`}</code><br />

<code>{`
<meta name="viewport" content="width=device-width, initial-scale=1" />
`}</code><br />

<code>{`
<meta name="theme-color" content="#000000" />
`}</code><br />

<code>{`
<script src="https://use.fontawesome.com/ae82b2007b.js"></script>
`}</code><br />

<code>{`
<link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" />
`}</code><br />

<code>{`
<link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
`}</code><br />

<code>{`
<link rel="preconnect" href="https://fonts.gstatic.com" />
`}</code><br />

<code>{`
<link href="https://fonts.googleapis.com/css2?family=Gentium+Book+Basic&family=Yesteryear&display=swap" rel="stylesheet" />
`}</code><br />

<code>{`

`}</code><br />

<code>{`
<title>{props.title}</title>
`}</code><br />

<code>{`
<meta name="description" content={props.desc}/>
`}</code><br />

<code>{`

`}</code><br />

<code>{`
<meta name="og:site_name" content="Highway 60" />
`}</code><br />

<code>{`
<meta name="og:type" content="Application" />
`}</code><br />

<code>{`
<meta name="og:title" content={props.title} />
`}</code><br />

<code>{`
<meta name="og:description" content={props.desc} />
`}</code><br />

<code>{`
<meta name="og:url" content={props.URL} />
`}</code><br />

<code>{`
<meta property="og:image" content={props.imageURL}/> 
`}</code><br />

<code>{`

`}</code><br />

<code>{`
<meta name="twitter:card" content="summary_large_image" />
`}</code><br />

<code>{`
<meta name="twitter:creator" content="@TheHighway60" />
`}</code><br />

<code>{`
<meta name="twitter:title" content={props.title} />
`}</code><br />

<code>{`
<meta name="twitter: description" content={props.desc} />
`}</code><br />

<code>{`
<meta name="twitter: url" content={props.URL} />
`}</code><br />

<code>{`
<meta property="twitter:image" content={props.imageURL} />
`}</code><br />

<code>{`
  </Helmet>
`}</code><br />

<code>{`
        </>
`}</code><br />

<code>{`
        );
`}</code><br />

<code>{`
    }
`}</code><br />

<code>{`

`}</code><br />

<code>{`
export default MetaTags;
`}</code><br />

<br />
</div>

<p>
    Now, let’s go back to the home page and put in our props.
</p>

<p>
    But first, I have to import my &#123;Helmet&#125; hook, my MetaTags component, and an image:
</p>

<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />

<code>{`
import planet from '../pictures/planet_img.jpg';
`}</code><br />

<code>{`
import MetaTags from './MetaTags';
`}</code><br />

<br />
</div>

<p>
    Now, let’s call the component and set our props:
</p>

<div style={{textAlign: "left", marginLeft: "15%", fontSize: "1.25em"}}>
    <br />

<code>{`
<MetaTags title="Highway 60 Home Page" desc="Highway 60 is about coding, marketing, writing, high tech, and the people who make up the most beautiful stretch of Land on G-d's green earth." 
URL="https://highway-60.web.app/" imageURL={planet} />
`}</code><br />

<br />
</div>

<p>
    Did it work?
</p>

<p>
    For that, I need to upload the latest version of my app and paste it to FaceBook.
</p>

<p>
    Why not? Let’s give it a whirl.
</p>

<p>
    It didn’t work.
</p>

<p>I see that the tab up top taking in the &#60;title&#62; element did work. I see that the favicon I set also worked.
Let’s do more work:</p>

<p>
    Okay. The problem is that social media sites look to the server for their meta data and ReactJS is a client-side application. We need to improvise.
</p>

<p>
    One option is to use <b>react-static</b>, but I might have to redo my entire site.
</p>

<p>
    Another option is to start playing with the server side. But I am not ready for that.
</p>

<p>
    For now, I will have to be happy with google SERPS and a good title and favicon up top.
</p>

<p>
    The rest will have to wait until I can dive deeper.
</p>
<br/>
<h1>
    Happy No Year
</h1>
<div id="thumbsUp" class="fa fa-road" style={{fontSize: '4em', marginTop: '2px', color: 'charcoal'}} />

<p>
This morning I take my son to the bus. Ahmed is really cool. He waits patiently as Ari finds his spot and gets comfortable. When my son starts to jump around in his seat, Ahmed even gives him a piece of candy. 
</p>

<p>
    Lot's of good people in my country. 
</p>

<p>
    Today, he smiles at me and says "Dave, happy no year!"
</p>

<p>"Huh? What's no year?"</p>

<p>He asks me, "When was new year for you?"</p>

<p>"Rosh HaShana was three months ago."</p>

<p>"For me, youm-e-ashura was four months ago."</p>

<p>Ahmed lives about 10km north of us, on the 60. He lives in a huge Arab city of <i>al-Nasrat</i>, what the people of Fon-Du-Lac Wisconsin call Nazareth. There is about a 20% Christian population there so he sees all the decorations for Christmas and New Year's, but as a Muslim, his calendar changes a few months earlier.</p>

<p>"Sounds great. Well, happy no year. See you tomrrow."</p>
<div id="thumbsUp" class="fa fa-road" style={{fontSize: '4em', marginTop: '2px', color: 'charcoal'}} />

<TraversePosts prevURL="/articles/the-dating-game" nextURL="/articles/go-with-God"/>

<Connect />
</motion.div>
  );
}

export default PutOnYourHelmet;
